import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useEffect, useRef, useState } from "react";
import LocationFilters from "./location-filters/location-filters";
import { SEARCH_BAR_HEIGHT, SHADOW_VERTICAL_OFFSET, StyledSearchBarCareersComponent } from "./search-bar-careers-component.scss";
import TeamsFilters from "segments/desktop/careers/layouts/search-bar-careers/teams-filter/teams-filters";
import SearchInput from "./search-input/search-input";
import { useFilters } from "contexts/careers-context";
import { POSITIONS_ID } from "segments/desktop/careers/layouts/consts";
import HeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
import { SHOW_LOCATION_FILTER } from "components/pages/careers/careers-constants.js";
const LOCATION_URL_PARAM = "location";
const DEPARTMENT_URL_PARAM = "department";
const SEARCH_TERM_URL_PARAM = "search";
const HEADERS_HEIGHT = SEARCH_BAR_HEIGHT + HeaderConstants.BASIC_HEADER_HEIGHT + SHADOW_VERTICAL_OFFSET;
const SearchBarCareersComponent = ({})=>{
    const { setSearch, search, setDepartment, setLocation, department, location, positionsPerLocation } = useFilters();
    const [isAtTop, setIsAtTop] = useState(false);
    const filtersRef = useRef(null);
    useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const locationId = params.get(LOCATION_URL_PARAM);
        const departmentId = params.get(DEPARTMENT_URL_PARAM);
        const searchTerm = params.get(SEARCH_TERM_URL_PARAM);
        locationId && setLocation(locationId);
        departmentId && setDepartment(departmentId);
        searchTerm && setSearch(searchTerm);
    }, []);
    const updateUrlParams = ({ location = location, team = department })=>{
        window.history.pushState({}, "", window.location.href);
        const params = new URLSearchParams(window.location.search);
        location ? params.set(LOCATION_URL_PARAM, location) : params.delete(LOCATION_URL_PARAM);
        team ? params.set(DEPARTMENT_URL_PARAM, team) : params.delete(DEPARTMENT_URL_PARAM);
        search ? params.set(SEARCH_TERM_URL_PARAM, search) : params.delete(SEARCH_TERM_URL_PARAM);
        window.history.pushState({}, "", `?${params.toString()}`);
    };
    useEffect(()=>{
        const handleScroll = ()=>{
            var _filtersRef_current;
            setIsAtTop(((_filtersRef_current = filtersRef.current) === null || _filtersRef_current === void 0 ? void 0 : _filtersRef_current.getBoundingClientRect().top) <= HeaderConstants.BASIC_HEADER_HEIGHT);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    const scrollToPositions = ()=>{
        const positionsElement = document.querySelector(`#${POSITIONS_ID}`);
        if (!positionsElement) return;
        const elementPosition = positionsElement.getBoundingClientRect().top + window.scrollY;
        const positionToScrollTo = elementPosition - HEADERS_HEIGHT;
        window.scrollTo({
            behavior: "smooth",
            top: positionToScrollTo
        });
    };
    const performSearch = ()=>{
        updateUrlParams({});
        scrollToPositions();
    };
    const onLocationChange = (selectedLocation)=>{
        const userSelectedLocation = selectedLocation === location ? null : selectedLocation;
        setLocation(userSelectedLocation);
        updateUrlParams({
            location: userSelectedLocation
        });
        scrollToPositions();
    };
    const onTeamChange = (team)=>{
        const userSelectedTeam = team === department ? null : team;
        setDepartment(userSelectedTeam);
        updateUrlParams({
            team: userSelectedTeam
        });
        scrollToPositions();
    };
    return /*#__PURE__*/ _jsx(StyledSearchBarCareersComponent, {
        ref: filtersRef,
        className: classnames({
            "nav-bar": isAtTop
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "search-input-and-filters",
            children: [
                /*#__PURE__*/ _jsx(SearchInput, {
                    onChange: setSearch,
                    value: search,
                    onSearch: performSearch
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "filters",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "title",
                            children: "Filters"
                        }),
                        SHOW_LOCATION_FILTER && /*#__PURE__*/ _jsx(LocationFilters, {
                            positionsPerLocation: positionsPerLocation,
                            onLocationChange: onLocationChange,
                            selectedLocationId: location
                        }),
                        /*#__PURE__*/ _jsx(TeamsFilters, {
                            onTeamChange: onTeamChange,
                            selectedTeamId: department
                        })
                    ]
                })
            ]
        })
    });
};
export default SearchBarCareersComponent;
